<template>
  <div id="app" class="accommodation-report-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-3" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info">
              <v-toolbar-title>{{ $t('Accommodation-Report') }}</v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="reportForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-card-text class="pb-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md2 pa-1>
                          <v-select
                            v-model="filters.TarihTip"
                            :items="dateTypeItems"
                            item-text="text"
                            item-value="value"
                            :label="$t('Date-Type')"
                            hide-details
                          ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pa-1>
                          <tarihcomp
                            :etiket="$t('Starting-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="filters.BaslangicTarihi"
                            v-model="filters.BaslangicTarihi"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pa-1>
                          <tarihcomp
                            :etiket="$t('Finishing-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="filters.BitisTarihi"
                            v-model="filters.BitisTarihi"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 sm6 md3 pa-1>
                          <div class="filter-actions">
                            <v-btn
                              v-if="!progress"
                              color="info"
                              fab
                              small
                              dark
                              @click="getList"
                            >
                              <v-icon>search</v-icon>
                            </v-btn>

                            <v-progress-circular
                              v-else
                              indeterminate
                              :width="4"
                              color="blue"
                              size="28"
                            ></v-progress-circular>

                            <v-badge color="white" :overlap="true">
                              <template v-slot:badge>
                                <v-icon v-if="filtrevarmi" large color="green">
                                  check_circle_outline
                                </v-icon>
                              </template>

                              <v-tooltip bottom>
                                <v-btn
                                  slot="activator"
                                  color="info"
                                  fab
                                  small
                                  dark
                                  @click="filtrele"
                                >
                                  <v-icon>filter_list</v-icon>
                                </v-btn>
                                <span>{{ $t('Add-Search-Filter') }}</span>
                              </v-tooltip>
                            </v-badge>

                            <v-tooltip bottom max-width="420">
                              <v-btn
                                slot="activator"
                                icon
                                small
                                color="warning"
                                class="report-data-help-button"
                                :aria-label="$t('Report-Data-Quality-Info')"
                              >
                                <v-icon color="white">help_outline</v-icon>
                              </v-btn>
                              <span class="report-data-help-text">
                                {{
                                  $t(
                                    'Accommodation-Data-Quality-Description'
                                  )
                                }}
                              </span>
                            </v-tooltip>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat>
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12>
                          <ReportTable
                            :headers="headers"
                            :items="tableItems"
                            :loading="progress"
                            :has-searched="hasSearched"
                            storage-key="konaklama_raporu_table"
                            :search-label="$t('Search')"
                            :show-frontend-export="true"
                            :rows-per-page-items="[20, 50, 100]"
                          >
                            <template slot="actions">
                              <div class="co2-action-group">
                                <img
                                  :src="co2CalculateIcon"
                                  class="co2-calculate-icon"
                                  alt="CalCo2AI"
                                >
                                <v-btn
                                  color="success"
                                  :loading="co2Calculating"
                                  :disabled="co2Calculating || progress || !tableItems.length"
                                  @click="openCo2CalculateDialog"
                                >
                                  {{ $t('Calculate-CO2') }}
                                  <v-tooltip bottom>
                                    <v-icon
                                      slot="activator"
                                      class="co2-help-icon"
                                      role="button"
                                      :aria-label="$t('How-Does-It-Work')"
                                      @click.stop="co2HelpDialog = true"
                                    >
                                      help_outline
                                    </v-icon>
                                    <span>{{ $t('How-Does-It-Work') }}</span>
                                  </v-tooltip>
                                </v-btn>
                              </div>
                            </template>
                            <template slot="cell" slot-scope="slotProps">
                              <div class="accommodation-report-cell">
                                {{ slotProps.value }}
                              </div>
                            </template>
                          </ReportTable>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-dialog
            v-model="locationChoiceDialog"
            persistent
            max-width="620px"
          >
            <v-card>
              <v-card-title class="headline">
                {{ $t('Missing-Hotel-Locations') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-3">
                <v-alert type="warning" :value="true" class="mb-3">
                  {{
                    $t('Missing-Hotel-Locations-Warning')
                  }}
                </v-alert>
                <p class="mb-2">
                  {{
                    $t(
                      'Find-Hotel-Locations-Description'
                    ) }}
                </p>
                <p class="mb-0">
                  {{
                    $t('Continue-With-Located-Records-Description')
                  }}
                </p>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="location-choice-actions">
                <v-btn flat @click="locationChoiceDialog = false">
                  {{ $t('Cancel') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="warning"
                  dark
                  @click="continueWithLocatedRecords"
                >
                  {{ $t('Continue-With-Located-Records') }}
                </v-btn>
                <v-btn
                  color="info"
                  dark
                  :loading="locationLoading"
                  :disabled="true"
                  @click="findHotelLocations"
                >
                  <v-icon left>place</v-icon>
                  {{ $t('Find-Hotel-Locations-Slice-3') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="locationResultDialog"
            persistent
            max-width="620px"
          >
            <v-card>
              <v-card-title class="headline">
                {{ $t('Hotel-Location-Result') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-3">
                <div class="location-summary-grid">
                  <div>{{ $t('Total-Accommodation') }}</div>
                  <strong>{{ locationSummary.totalAccommodation }}</strong>
                  <div>{{ $t('Already-Located') }}</div>
                  <strong>{{ locationSummary.alreadyLocated }}</strong>
                  <div>{{ $t('Found-By-Geocoding') }}</div>
                  <strong>{{ locationSummary.foundByGeocoding }}</strong>
                  <div>{{ $t('Unresolved') }}</div>
                  <strong>{{ locationSummary.unresolved }}</strong>
                  <div>{{ $t('Location-Coverage-Rate') }}</div>
                  <strong>%{{ locationSummary.coverageRate }}</strong>
                  <div>{{ $t('Excluded-From-Calculation') }}</div>
                  <strong>{{ locationSummary.skippedCount }}</strong>
                </div>

                <v-alert
                  v-if="locationSummary.unresolved > 0"
                  type="warning"
                  :value="true"
                  class="mt-3 mb-0"
                >
                  {{ $t(
                    'Unresolved-Records-CO2-Warning') }}
                </v-alert>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn flat @click="locationResultDialog = false">
                  {{ $t('Cancel') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" dark @click="continueAfterLocationSearch">
                  {{ $t('Continue-To-CO2-Calculation') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="co2CalculateDialog" persistent max-width="560px">
            <v-card>
              <v-card-title class="headline">{{ $t('CO2-Calculation-Confirmation') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-3">
                <p>
                  {{ $t('Filtered-Report-Has') }}
                  <strong>{{ pendingCo2AccommodationCount }} {{ $t('Accommodation') }}</strong>
                  {{ $t('Accommodation-Credit-Rule') }}
                  {{ $t('Maximum-Credit-Usage') }}
                  <strong>{{ requiredCo2Credits }} {{ $t('Credit') }}</strong>
                  {{ $t('Will-Be-Used') }}
                </p>
                <p>
                  {{ $t('Last-Known-Available-Credits') }}:
                  <strong>
                    {{ co2CurrentCredits != null ? co2CurrentCredits : $t('Not-Known-Yet') }}
                  </strong>
                  <span v-if="co2CurrentCredits != null">
                    &nbsp;— {{ $t('Estimated-Remaining-After-Operation') }}:
                    <strong>{{ estimatedCo2CreditsAfter }}</strong>
                  </span>
                </p>
                <v-alert
                  v-if="co2CreditsInsufficient"
                  type="warning"
                  :value="true"
                  class="mb-3"
                >
                  {{ $t(
                    'Insufficient-Credits-Warning') }}
                </v-alert>
                <p v-else class="mb-0">
                  {{ $t(
                    'Get-Credits-From-CalCo2AI') }}
                </p>

                <v-alert type="info" :value="true" class="mt-3 mb-0">
                  {{
                    $t('Geocoding-Privacy-Notice')
                  }}
                </v-alert>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn flat color="info" @click="openCalCo2Portal">
                  <v-icon left>open_in_new</v-icon>
                  {{ $t('CalCo2AI-Portal') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn flat @click="co2CalculateDialog = false">{{ $t('Cancel') }}</v-btn>
                <v-btn
                  color="success"
                  dark
                  @click="confirmAccommodationCo2Calculate"
                >
                  {{ $t('Calculate') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="co2InsufficientDialog"
            persistent
            max-width="560px"
          >
            <v-card>
              <v-toolbar dense flat color="warning" dark>
                <v-icon class="mr-2">account_balance_wallet</v-icon>
                <v-toolbar-title>{{ $t('Insufficient-Credits') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="pt-4">
                <v-alert type="warning" :value="true" class="mb-3">
                  {{ $t(
                    'Accommodation-CO2-Insufficient-Credits') }}
                </v-alert>
                <p>
                  {{ $t('Available-Credits') }}:
                  <strong>
                    {{ co2CurrentCredits != null ? co2CurrentCredits : $t('Unknown') }}
                  </strong>
                </p>
                <p>
                  {{ $t('Estimated-Required-Credits') }}:
                  <strong>{{ requiredCo2Credits }}</strong>
                </p>
                <p class="mb-0">
                  {{
                    $t('Credit-Purchase-Instructions')
                  }}
                </p>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="co2-insufficient-actions">
                <v-btn flat color="info" @click="openCo2HelpFromInsufficient">
                  <v-icon left>play_circle_outline</v-icon>
                  {{ $t('Watch-Help-Video') }}
                </v-btn>
                <v-btn flat color="success" @click="openCalCo2Portal">
                  <v-icon left>open_in_new</v-icon>
                  {{ $t('Buy-Credits') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn flat @click="co2InsufficientDialog = false">
                  {{ $t('Close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-if="co2HelpDialog"
            v-model="co2HelpDialog"
            max-width="800px"
            width="95vw"
          >
            <v-card>
              <v-card-title class="headline co2-help-title">
                {{ $t('Carbon-Calculation-How-It-Works') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-3 pa-sm-4">
                <div class="co2-video-container">
                  <iframe
                    v-if="videoUrl"
                    :src="videoUrl"
                    :title="$t('CalCo2AI-Introduction-Video')"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <div v-else class="co2-video-placeholder">
                    {{ $t('Video-Coming-Soon') }}
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="info" @click="co2HelpDialog = false">
                  {{ $t('Close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>

              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 pa-1>
                    <pnrbul v-model="filters.PNR_No" hide-details></pnrbul>
                  </v-flex>

                  <v-flex xs12 pa-1>
                    <v-text-field
                      v-model="filters.Otel"
                      :label="$t('Hotel')"
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 pa-1>
                    <v-text-field
                      v-model="filters.Ulke"
                      :label="$t('Country_label')"
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 pa-1>
                    <v-text-field
                      v-model="filters.Sehir"
                      :label="$t('City')"
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 pa-1>
                    <cariaracomp
                      :etiket="$t('Current')"
                      :value="filters.Cari"
                      v-model="filters.Cari"
                      :Coper="true"
                    ></cariaracomp>
                  </v-flex>

                  <v-flex xs12 pa-1>
                    <v-select
                      v-model="filters.HatTipi"
                      :items="lineTypeItems"
                      item-text="text"
                      item-value="value"
                      :label="$t('Line-Type')"
                      hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="filtreiptal">
                  {{ $t('cancel_button') }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="filtrekayit">
                  {{ $t('Apply-Filters') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-snackbar
            :timeout="6000"
            top
            right
            v-model="snackbar"
          >
            {{ snackbarText }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "@/components/app/customcomp/tarihim.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";
import imgSrcCalCo2FlightIcon from "@/assets/images/calco2ai-flight-icon.png";
import tool from "@/components/app/coper/tools.js";

// Backend endpoint adı netleşince yalnızca bu sabiti değiştirin.
const ACCOMMODATION_REPORT_ENDPOINT =
  "CoperReport/AccommodationReport";
const ACCOMMODATION_CO2_ENDPOINT =
  "CoperReport/AccommodationCo2Calculate";
const ACCOMMODATION_LOCATION_ENRICH_ENDPOINT =
  "[BACKEND_LOCATION_ENRICH_ENDPOINT_ADI]";

// Backend SayfaYetkiInfo listesine yeni sayfa eklendiğinde
// "coper-konaklamaraporu" yapın. null iken route oturumu zorunlu tutar,
// ayrıca henüz var olmayan sayfa yetkisini aramaz.
const ACCOMMODATION_REPORT_AUTH_PAGE = null;

// Backend response alanları büyük/küçük harfe duyarlıdır.
// Kesin alan adları geldiğinde yalnızca bu nesnedeki değerleri değiştirin.
const ACCOMMODATION_REPORT_FIELDS = Object.freeze({
  registrationDate: "KayitTarihiText",
  pnr: "PNR_No",
  hotel: "OtelAdi",
  checkInDate: "GirisTarihiText",
  checkOutDate: "CikisTarihiText",
  nightCount: "Gece",
  country: "Ulke",
  city: "Sehir",
  guestCount: "KisiAdedi",
  roomCount: "OdaSayisi",
  currentCode: "CariKod",
  co2: "Co2",
  co2CalculationDate: "Co2HesapTarText"
});

function createHeaders(vm) {
  return [
    { text: vm.$t("Record-Date"), value: ACCOMMODATION_REPORT_FIELDS.registrationDate, type: "text", align: "center", visible: true, sortable: true, minWidth: "140px" },
    { text: "PNR", value: ACCOMMODATION_REPORT_FIELDS.pnr, type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Hotel"), value: ACCOMMODATION_REPORT_FIELDS.hotel, type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Check-In"), value: ACCOMMODATION_REPORT_FIELDS.checkInDate, type: "text", align: "center", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Check-Out"), value: ACCOMMODATION_REPORT_FIELDS.checkOutDate, type: "text", align: "center", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Night"), value: ACCOMMODATION_REPORT_FIELDS.nightCount, type: "number", align: "right", visible: true, sortable: true, minWidth: "100px" },
    { text: vm.$t("Country_label"), value: ACCOMMODATION_REPORT_FIELDS.country, type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("City"), value: ACCOMMODATION_REPORT_FIELDS.city, type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Guest-Count"), value: ACCOMMODATION_REPORT_FIELDS.guestCount, type: "number", align: "right", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Room-Count"), value: ACCOMMODATION_REPORT_FIELDS.roomCount, type: "number", align: "right", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Currentcode_label"), value: ACCOMMODATION_REPORT_FIELDS.currentCode, type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "CO2 (kg)", value: ACCOMMODATION_REPORT_FIELDS.co2, type: "number", align: "right", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("CO2-Calculation-Date"), value: ACCOMMODATION_REPORT_FIELDS.co2CalculationDate, type: "text", align: "center", visible: true, sortable: true, minWidth: "160px" }
  ];
}

function emptyFilters() {
  return {
    TarihTip: 0,
    BaslangicTarihi: null,
    BitisTarihi: null,
    PNR_No: null,
    Otel: null,
    Ulke: null,
    Sehir: null,
    Cari: null,
    HatTipi: 0
  };
}

export default {
  name: "KonaklamaRaporu",
  components: {
    tarihcomp,
    yetkidialog,
    cariaracomp,
    pnrbul,
    ReportTable
  },
  data() {
    return {
      valid: true,
      progress: false,
      hasSearched: false,
      filtrevarmi: false,
      dialogfiltre: false,
      snackbar: false,
      snackbarText: "",
      items: [],
      co2CalculateIcon: imgSrcCalCo2FlightIcon,
      co2Calculating: false,
      co2CalculateDialog: false,
      co2InsufficientDialog: false,
      co2HelpDialog: false,
      locationChoiceDialog: false,
      locationResultDialog: false,
      locationLoading: false,
      locationSummary: {
        totalAccommodation: 0,
        alreadyLocated: 0,
        foundByGeocoding: 0,
        unresolved: 0,
        coverageRate: 0,
        skippedCount: 0
      },
      videoUrl: "https://www.youtube.com/embed/AEKivDNho34",
      co2CurrentCredits: null,
      headers: createHeaders(this),
      filters: emptyFilters(),
      dateRules: [v => !!v || this.$t("Please-select-a-date")],
      dateTypeItems: [
        { text: this.$t("Record-Date"), value: 0 },
        { text: this.$t("Check-In-Date"), value: 1 },
        { text: this.$t("Check-Out-Date"), value: 2 }
      ],
      lineTypeItems: [
        { text: this.$t("All-v2"), value: 0 },
        { text: this.$t("Domestic"), value: 1 },
        { text: this.$t("International"), value: 2 }
      ],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },
      prevRoute: null
    };
  },
  computed: {
    tableItems() {
      if (!Array.isArray(this.items)) {
        return [];
      }

      return this.items.map(item => {
        const copyItem = Object.assign({}, item);
        copyItem.KayitTarihiText = helpers.dateformat(item.KayitTarihi);
        copyItem.GirisTarihiText = helpers.dateformat(item.GirisTarihi);
        copyItem.CikisTarihiText = helpers.dateformat(item.CikisTarihi);
        copyItem.Co2HesapTarText = helpers.dateformat(item.Co2HesapTar);
        copyItem.Ulke = item.Ulke == null ? "" : item.Ulke;
        copyItem.Sehir = item.Sehir == null ? "" : item.Sehir;
        return copyItem;
      });
    },
    pendingCo2AccommodationCount() {
      return this.tableItems.filter(item => item.Co2 == null).length;
    },
    requiredCo2Credits() {
      return Math.ceil(this.pendingCo2AccommodationCount / 5);
    },
    co2CreditsInsufficient() {
      return (
        this.co2CurrentCredits != null &&
        this.co2CurrentCredits < this.requiredCo2Credits
      );
    },
    estimatedCo2CreditsAfter() {
      if (this.co2CurrentCredits == null) {
        return "-";
      }
      return Math.max(0, this.co2CurrentCredits - this.requiredCo2Credits);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    if (!ACCOMMODATION_REPORT_AUTH_PAGE) {
      return;
    }

    this.sayfayetki = helpers.pageScreenAuth(ACCOMMODATION_REPORT_AUTH_PAGE);

    if (this.sayfayetki.Status !== true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then(sonuc => {
          if (sonuc === true) {
            window.open(this.prevRoute ? "#" + this.prevRoute : "#/", "_self");
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    openCo2CalculateDialog() {
      const credentials = JSON.parse(
        window.localStorage.getItem("credentials") || "{}"
      );
      const customerID = credentials.MusteriID || "unknown";
      const storedBalance = window.localStorage.getItem(
        "calco2_balance_" + customerID
      );

      this.co2CurrentCredits =
        storedBalance != null && storedBalance !== ""
          ? Number(storedBalance)
          : null;
      this.locationChoiceDialog = true;
    },
    continueWithLocatedRecords() {
      this.locationChoiceDialog = false;
      this.co2CalculateDialog = true;
    },
    findHotelLocations() {
      if (this.locationLoading) {
        return;
      }

      this.locationLoading = true;
      tool
        .api_post(
          this,
          ACCOMMODATION_LOCATION_ENRICH_ENDPOINT,
          this.createReportParams()
        )
        .then(response => {
          const body = response.body || {};
          const data = body.data || body;
          const total = Number(
            data.TotalAccommodation || data.ToplamKonaklama || 0
          );
          const alreadyLocated = Number(
            data.AlreadyLocated || data.KonumuMevcut || 0
          );
          const foundByGeocoding = Number(
            data.FoundByGeocoding || data.GeocodingIleBulunan || 0
          );
          const unresolved = Number(
            data.Unresolved || data.Bulunamayan || 0
          );
          const locatedTotal = alreadyLocated + foundByGeocoding;
          const coverageRate =
            data.CoverageRate != null
              ? Number(data.CoverageRate)
              : total > 0
                ? Math.round((locatedTotal / total) * 100)
                : 0;

          this.locationSummary = {
            totalAccommodation: total,
            alreadyLocated,
            foundByGeocoding,
            unresolved,
            coverageRate,
            skippedCount: Number(
              data.SkippedCount != null ? data.SkippedCount : unresolved
            )
          };
          this.locationChoiceDialog = false;
          this.locationResultDialog = true;
        })
        .catch(error => {
          const body =
            error && (error.body || error.data)
              ? error.body || error.data
              : {};
          this.snackbarText =
            body.ResponseMessage ||
            body.Message ||
            body.message ||
            this.$t("Hotel-Locations-Could-Not-Be-Found");
          this.snackbar = true;
        })
        .then(() => {
          this.locationLoading = false;
        });
    },
    continueAfterLocationSearch() {
      this.locationResultDialog = false;
      this.co2CalculateDialog = true;
    },
    openCalCo2Portal() {
      window.open("https://portal.calco2ai.com/", "_blank");
    },
    confirmAccommodationCo2Calculate() {
      this.co2CalculateDialog = false;
      if (this.co2CreditsInsufficient) {
        this.co2InsufficientDialog = true;
        return;
      }
      this.calculateAccommodationCo2();
    },
    openCo2HelpFromInsufficient() {
      this.co2InsufficientDialog = false;
      this.co2HelpDialog = true;
    },
    calculateAccommodationCo2() {
      if (this.co2Calculating || !this.$refs.reportForm.validate()) {
        return;
      }

      const baslangic = new Date(this.filters.BaslangicTarihi);
      const bitis = new Date(this.filters.BitisTarihi);
      if (baslangic > bitis) {
        this.snackbarText = this.$t(
          "start-date-cannot-greater-than-end-date"
        );
        this.snackbar = true;
        return;
      }

      const credentials = JSON.parse(
        window.localStorage.getItem("credentials") || "{}"
      );
      const params = this.createReportParams();
      params.Filtreler.ForceRecalculate = false;

      this.co2Calculating = true;
      tool
        .api_post(this, ACCOMMODATION_CO2_ENDPOINT, params)
        .then(response => {
          const result = response.body || {};

          if (result.Status === false) {
            this.snackbarText =
              this.$t("CalCo2AI-Marketplace-Configuration-Required") + " " +
              (result.ResponseMessage || "");
            this.snackbar = true;
            return;
          }

          if (result.KalanKontor != null) {
            this.co2CurrentCredits = Number(result.KalanKontor);
            window.localStorage.setItem(
              "calco2_balance_" + credentials.MusteriID,
              String(result.KalanKontor)
            );
          }

          this.snackbarText =
            (result.HesaplananKonaklama || result.HesaplananKayit || 0) +
            " " + this.$t("Accommodation-Calculated") + ", " +
            (result.AtlananKonaklama || result.AtlananKayit || 0) +
            " " + this.$t("Skipped") + ". " + this.$t("Credits-Used") + ": " +
            (result.KullanilanKontor || 0) +
            ". " + this.$t("Credits-Remaining") + ": " +
            (result.KalanKontor != null ? result.KalanKontor : "-");
          this.snackbar = true;
          this.getList();
        })
        .catch(error => {
          const body =
            error && (error.body || error.data)
              ? error.body || error.data
              : {};

          if (error && error.status === 402) {
            const availableCredits =
              body.KalanKontor != null
                ? body.KalanKontor
                : body.credits_available;

            if (availableCredits != null) {
              this.co2CurrentCredits = Number(availableCredits);
              window.localStorage.setItem(
                "calco2_balance_" + credentials.MusteriID,
                String(availableCredits)
              );
            }
            this.co2InsufficientDialog = true;
          } else if (body.Status === false) {
            this.snackbarText =
              this.$t("CalCo2AI-Marketplace-Configuration-Required") + " " +
              (body.ResponseMessage || "");
          } else {
            this.snackbarText =
              body.ResponseMessage ||
              body.Message ||
              body.message ||
              this.$t("CO2-Could-Not-Be-Calculated");
          }
          if (!error || error.status !== 402) {
            this.snackbar = true;
          }
        })
        .then(() => {
          this.co2Calculating = false;
        });
    },
    filtrele() {
      this.dialogfiltre = true;
    },
    filtrekayit() {
      this.filtrevarmi = true;
      this.dialogfiltre = false;
      this.getList();
    },
    filtreiptal() {
      const preservedDates = {
        TarihTip: this.filters.TarihTip,
        BaslangicTarihi: this.filters.BaslangicTarihi,
        BitisTarihi: this.filters.BitisTarihi
      };

      this.filters = Object.assign(emptyFilters(), preservedDates);
      this.filtrevarmi = false;
      this.dialogfiltre = false;
      this.getList();
    },
    getCariCode(cari) {
      if (!cari) return null;
      if (typeof cari === "string") return cari;
      return cari.id || cari.kod || cari.CariKod || cari.value || null;
    },
    createReportParams() {
      return {
        Filtreler: {
          BaslangicTarihi: this.filters.BaslangicTarihi,
          BitisTarihi: this.filters.BitisTarihi,
          TarihTip: Number(this.filters.TarihTip),
          CariKod: this.getCariCode(this.filters.Cari) || "",
          OtelAra: this.filters.Otel || "",
          Ulke: this.filters.Ulke || "",
          Sehir: this.filters.Sehir || "",
          PnrNo: this.filters.PNR_No || null,
          HatTipi: Number(this.filters.HatTipi),
          IptalleriDahilEt: false
        }
      };
    },
    getList() {
      if (!this.$refs.reportForm.validate()) {
        return;
      }

      const baslangic = new Date(this.filters.BaslangicTarihi);
      const bitis = new Date(this.filters.BitisTarihi);

      if (baslangic > bitis) {
        this.snackbarText = this.$t(
          "start-date-cannot-greater-than-end-date"
        );
        this.snackbar = true;
        return;
      }

      this.hasSearched = true;
      this.progress = true;

      tool
        .api_post(this, ACCOMMODATION_REPORT_ENDPOINT, this.createReportParams())
        .then(response => {
          const body = response.body || {};

          if (body.Status !== true) {
            this.items = [];
            this.snackbarText =
              body.ResponseMessage ||
              body.Message ||
              (body.ErrorList && body.ErrorList[0]) ||
              this.$t("Report-Could-Not-Be-Retrieved");
            this.snackbar = true;
            return;
          }

          this.items = Array.isArray(body.data) ? body.data : [];
        })
        .catch(response => {
          const body = response && (response.body || response.data);
          this.items = [];
          this.snackbarText =
            (body && (body.Message || body.message || body.ResponseMessage)) ||
            "Service Unavailable";
          this.snackbar = true;
        })
        .then(() => {
          this.progress = false;
        });
    }
  }
};
</script>

<style scoped>
.filter-actions {
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.report-data-help-button {
  margin: 0;
}

.report-data-help-text {
  display: inline-block;
  max-width: 390px;
  line-height: 1.45;
}

.location-choice-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.location-summary-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px 24px;
  align-items: center;
}

.accommodation-report-cell {
  white-space: nowrap;
}

.co2-action-group {
  display: inline-flex;
  align-items: center;
}

.co2-calculate-icon {
  display: block;
  width: 84px;
  height: 36px;
  margin-right: 6px;
  object-fit: contain;
}

.co2-help-icon {
  color: #ffffff !important;
  font-size: 28px !important;
  margin-left: 12px;
  cursor: pointer;
}

.co2-help-title {
  word-break: normal;
}

.co2-video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  background: #eeeeee;
}

.co2-video-container iframe,
.co2-video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.co2-video-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: #616161;
  font-size: 18px;
  text-align: center;
}

.co2-insufficient-actions {
  flex-wrap: wrap;
  gap: 6px;
}

@media (max-width: 600px) {
  .co2-help-title {
    padding: 16px;
    font-size: 18px !important;
    line-height: 1.35 !important;
  }

  .co2-video-placeholder {
    font-size: 15px;
  }
}
</style>
